export default __webpack_public_path__ + "static/media/area-54.71ebf4c3.jpg";